<script>
import appConfig from "@/app.config";
import {notifyModel} from "@/models/notifyModel";
import {pagingModel} from "@/models/pagingModel";
import {CONSTANTS} from "@/helpers/constants";
import {appleConnectorModel} from "@/models/appleConnector";
import Multiselect from "vue-multiselect";
import _ from "lodash";

export default {
  page: {
    title: "IOS Management",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {Multiselect},
  data() {
    return {
      title: "IOS Management",
      data: [],
      showDeleteModal: false,
      showProcessModal: false,
      submitted: false,
      model: appleConnectorModel.baseJson(),
      listCoQuan: [],
      pagination: pagingModel.baseJson(),
      totalRows: 1,
      todoTotalRows: 1,
      currentPage: 1,
      numberOfElement: 1,
      perPage: 10,
      pageOptions: [5,10, 25, 50, 100],
      filter: null,
      isBusy: false,
      sortBy: "age",
      sortDesc: false,
      fields: [
        { key: 'STT',
          label: 'STT',
          class: 'td-stt',
          sortable: false,
          thClass: 'hidden-sortable',
          thStyle: { width: '30px', minWidth: '30px' },
        },
        {
          key: "appleID",
          label: "Apple ID",
          sortable: true,
          thStyle:"text-align:left; max-width: 200px",
          thClass: 'hidden-sortable title-capso',
        },
        {
          key: "fullName",
          label: "Họ và tên",
          sortable: true,
          thStyle:"text-align:left",
          thClass: 'hidden-sortable title-capso',
        },
        {
          key: "donVi",
          label: "Đơn vị",
          sortable: true,
          thClass: 'hidden-sortable title-capso',
          thStyle: {width: '250px', minWidth: '350px'},
          class: "text-center",
        },
        {
          key: "ghiChu",
          label: "Ghi chú",
          sortable: true,
          thStyle:"text-align:left",
          thClass: 'hidden-sortable title-capso',
        },
        {
          key: "daGiaiQuyet",
          label: "Đã giải quyết",
          thStyle: {width: '150px', minWidth: '150px'},
          class: "text-center",
          thClass: 'hidden-sortable title-capso',
        },
        {
          key: 'process',
          label: 'Xử lý',
          class: 'td-xuly btn-process',
          thClass: 'hidden-sortable',
          sortable: false,
          thStyle: { width: '120px', minWidth: '120px' },
        }
      ],
      itemFilter :{
        donVi: null,
        daGiaiQuyet: null,
        content: null,
      },
      trangThaiXem: [
        {
          id: "YEUCAUMOI",
          name: "Yêu cầu mới"
        },
        {
          id: "DAGIAIQUYET",
          name: "Đã giải quyết"
        }
      ],
      optionsDonVi: []
    };
  },
  created() {
    this.fnGetList();
    this.getDonVi();
    this.itemFilter.daGiaiQuyet = this.trangThaiXem[0]
  },
  watch: {
  },
  methods: {
    async getDonVi() {
        await this.$store.dispatch("donViStore/get").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.optionsDonVi = items;
          }
          return [];
        });
    },
    async fnGetList() {
      await this.onPageChange();
    },
    async onPageChange(page = 1) {
      this.pagination.currentPage = page;
      const params = {
        pageNumber: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      }
      this.$refs.tblList?.refresh()
    },
    async handleDelete() {
      if (this.model.id != null && this.model.id) {
        await this.$store.dispatch("appleConnectorStore/delete", this.model.id).then((res) => {
          if (res.resultCode === 'SUCCESS') {
            this.fnGetList();
            this.showDeleteModal = false;
            this.$refs.tblList.refresh()
            this.model = appleConnectorModel.baseJson();
          }
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
          // });
        });
      }
    },
    handleShowDeleteModal(id) {
      this.model.id = id;
      this.showDeleteModal = true;
    },
    handleShowProcessModal(model) {
      this.model = model;
      this.showProcessModal = true;
    },
    async handleSubmit(e) {
      e.preventDefault();
      if(!this.model || (this.model && !this.model.id))
          return;
      this.submitted = true;
      let loader = this.$loading.show({
        container: this.$refs.formContainer,
      });
      await this.$store.dispatch("appleConnectorStore/processAppleId", this.model).then((res) => {
        if (res.resultCode === 'SUCCESS') {
          this.fnGetList();
          this.showProcessModal = false;
          this.$refs.tblList.refresh()
          this.model = appleConnectorModel.baseJson();
        }
        this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res))
      })
      loader.hide();
      this.submitted = false;
    },
    myProvider (ctx) {
      const params = {
        start: ctx.currentPage,
        limit: ctx.perPage,
        content: this.itemFilter.content,
        daGiaiQuyet: this.itemFilter.daGiaiQuyet,
        donVi: this.itemFilter.donVi,
        sortBy: ctx.sortBy,
        sortDesc: ctx.sortDesc,
      }
      this.loading = true
      try {
        let promise =  this.$store.dispatch("appleConnectorStore/getPagingParams", params)
        return promise.then(resp => {
          if(resp.resultCode == CONSTANTS.SUCCESS){
            let data = resp.data;
            this.totalRows = data.totalRows
            let items = data.data
            this.numberOfElement = items.length
            this.loading = false
            return items || []
          }else{
            return [];
          }
        })
      } finally {
        this.loading = false
      }
    },
    clearSearch(){
      this.itemFilter= {
        donVi: null,
        daGiaiQuyet: null,
        content: null,
      };
      this.$refs.tblList?.refresh()
    },
    debounceInput: _.debounce(function (e) {
      if(this.itemFilter){
        this.itemFilter.content = e.target.value;
        this.$refs.tblList?.refresh()
      }
    }, 500),
    handleSearch(){
      this.$refs.tblList?.refresh()
    }
  }
}
</script>
<template>
  <div>
    <!--    <PageHeader :title="title" :items="items"/>-->
    <div class="row">
      <div class="col-12">
        <div class="card mb-2">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 col-12 d-flex align-items-center">
                <h4 class="font-size-18 fw-bold text-dark"> {{title}}</h4>
              </div>
              <div class="col-md-8 col-12 text-end">
                <b-button v-b-toggle.collapseSearch variant="light"
                          class="btn w-md btn-primary-outline me-2" size="sm">
                  <i class="fas fa-caret-down align-middle me-2"></i>
                  Tìm kiếm
                </b-button>

              </div>
            </div>
            <b-collapse id="collapseSearch" class="mt-1">
              <div class="row">
                <div class="col-12">
                  <div class="d-flex justify-content-between align-items-end flex-wrap mb-2">
                    <!-- Nội dung -->
                    <div class="flex-grow-1 me-2">
                      <label class="mb-1">Từ khoá</label>
                      <input size="sm" type="text" name="untyped-input" class="form-control"
                             v-on:input="debounceInput"
                             placeholder="Từ khoá"/>
                    </div>
                    <div class="flex-grow-1 me-2">
                      <label>Đơn vị </label>
                      <multiselect
                          v-model="itemFilter.donVi"
                          :options="optionsDonVi"
                          track-by="id"
                          label="ten"
                          placeholder="Chọn đơn vị "
                          deselect-label="Nhấn để xoá"
                          selectLabel="Nhấn enter để chọn"
                          selectedLabel="Đã chọn"
                      ></multiselect>
                    </div>

                    <div class="flex-grow-1 me-2">
                      <label class="mb-1">Trạng thái</label>
                      <multiselect v-model="itemFilter.daGiaiQuyet" :options="trangThaiXem" track-by="id" label="name"
                                   placeholder="Chọn trạng thái" deselect-label="Nhấn để xoá"
                                   selectLabel="Nhấn enter để chọn"
                                   selectedLabel="Đã chọn"></multiselect>
                    </div>

                    <div class="flex-grow-0 ms-2">
                      <div class="d-flex justify-content-between align-items-center flex-wrap">
                        <div class="flex-grow-1 mt-xl-0 mt-2">
                          <b-button @click="handleSearch" variant="light"
                                    class="btn w-md btn-primary me-2" size="md">
                            <i class="fas fa-search align-middle me-2"></i>
                            Tìm kiếm
                          </b-button>
                        </div>
                        <div class="flex-grow-1 mt-xl-0 mt-2">
                          <b-button @click="clearSearch" variant="light"
                                    class="btn w-md btn-secondary me-2" size="md">
                            <i class="fas fa-redo-alt align-middle me-2"></i>
                            Làm mới
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div class="row mb-3">
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Hiện
                        <b-form-select
                            class="form-select form-select-sm"
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                        ></b-form-select
                        >&nbsp;dòng
                      </label>
                    </div>
                  </div>
                </div>
                <div class="table-responsive-sm">
                  <b-table
                      class="datatables custom-table"
                      :items="myProvider"
                      :fields="fields"
                      striped
                      bordered
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :filter="filter"
                      :filter-included-fields="filterOn"
                      ref="tblList"
                      primary-key="id"
                      :busy.sync="isBusy"
                      tbody-tr-class="b-table-linhvuc"
                  >
                    <template v-slot:cell(STT)="data">
                      {{ data.index + ((currentPage-1)*perPage) + 1  }}
                    </template>
                    <template v-slot:cell(process)="data">
                      <button
                          v-if="!data.item.daGiaiQuyet"
                          type="button"
                          size="sm"
                          class="btn btn-edit btn-sm"
                          data-toggle="tooltip" data-placement="bottom" title="Cập nhật"
                          v-on:click="handleShowProcessModal(data.item)">
                        <i class="fas fa-pencil-alt"></i>
                      </button>
                      <button
                          type="button"
                          size="sm"
                          class="btn btn-delete btn-sm"
                          data-toggle="tooltip" data-placement="bottom" title="Xóa"
                          v-on:click="handleShowDeleteModal(data.item.id)">
                        <i class="fas fa-trash-alt"></i>
                      </button>
                    </template>
                    <template v-slot:cell(appleID)="data">
                      {{data.item.appleID}}
                    </template>
                    <template v-slot:cell(fullName)="data">
                      {{data.item.fullName}}
                    </template>
                    <template v-slot:cell(donVi)="data">
                      <div v-if="data.item.donVi">
                        {{ data.item.donVi.ten }}
                      </div>
                    </template>
                    <template v-slot:cell(ghiChu)="data">
                      {{data.item.ghiChu}}
                    </template>
                    <template v-slot:cell(daGiaiQuyet)="data">
                      <span v-if="data.item.daGiaiQuyet" class="badge bg-success px-2 py-1">Đã giải quyết</span>
                      <span  v-else class="badge bg-info px-2 py-1">Yêu cầu mới</span>
                    </template>
                  </b-table>
                  <template v-if="isBusy">
                    <div align="center">Đang tải dữ liệu</div>
                  </template>
                  <template v-if="totalRows <= 0 && !isBusy">
                    <div align="center">Không có dữ liệu</div>
                  </template>
                </div>
                <div class="row">
                  <b-col>
                    <div>Hiển thị {{numberOfElement}} trên tổng số {{totalRows}} dòng</div>
                  </b-col>
                  <div class="col">
                    <div
                        class="dataTables_paginate paging_simple_numbers float-end">
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <b-modal
            v-model="showDeleteModal"
            centered
            title="Xóa dữ liệu"
            title-class="font-18"
            no-close-on-backdrop
        >
          <p>
            Dữ liệu xóa sẽ không được phục hồi!
          </p>
          <template #modal-footer>
            <b-button v-b-modal.modal-close_visit
                      size="sm"
                      class="btn btn-outline-info w-md"
                      v-on:click="showDeleteModal = false">
              Đóng
            </b-button>
            <b-button v-b-modal.modal-close_visit
                      size="sm"
                      variant="danger"
                      type="button"
                      class="w-md"
                      v-on:click="handleDelete">
              Xóa
            </b-button>
          </template>
        </b-modal>

        <b-modal
            v-model="showProcessModal"
            centered
            title="Giải quyết yêu cầu"
            title-class="font-18"
            no-close-on-backdrop
        >
          <p>
              Giải quyết yêu cầu Apple Connector
          </p>
          <template #modal-footer>
            <b-button v-b-modal.modal-close_visit
                      size="sm"
                      class="btn btn-outline-info w-md"
                      v-on:click="showProcessModal = false">
              Đóng
            </b-button>
            <b-button v-b-modal.modal-close_visit
                      size="sm"
                      variant="success"
                      type="button"
                      class="w-md"
                      v-on:click="handleSubmit">
              Đồng ý
            </b-button>
          </template>
        </b-modal>
      </div>
    </div>
  </div>
</template>
<style>
.td-stt {
  text-align: center;
}
.td-xuly {
  text-align: center;
}
.table>tbody> tr >td{
  padding: 0px;
  line-height: 30px;
}
.hidden-sortable:after, .hidden-sortable:before {
  display: none !important;
}
@media only screen and (max-width: 768px) {
  .b-table-linhvuc>td:nth-of-type(1):before{
    content: "STT";
    font-weight: bold;
    color: #00568c;
  }
  .b-table-linhvuc>td:nth-of-type(2):before {
    content: "Tên";
    font-weight: bold;
    color: #00568c;
  }
  .b-table-linhvuc>td:nth-of-type(3):before {
    content: "Thứ tự";
    font-weight: bold;
    color: #00568c;
  }
  .b-table-linhvuc>td:nth-of-type(4):before {
    content: "";
    font-weight: bold;
    color: #00568c;
  }
}

</style>
